import { CmsFilters } from 'js/model/cms/cms-browse-page';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';

export const EXPRESS_TREATMENT_SERVICE_DURATION = 45;

export const isTreatmentTypesFilterActive = (
  selectedTreatmentTypes: string[]
): boolean => selectedTreatmentTypes.length > 0;

export const isExpressTreatmentTypeSelected = ({
  maxServiceDurationMinutes,
}: VenueListingSpecificationOutput) =>
  maxServiceDurationMinutes === EXPRESS_TREATMENT_SERVICE_DURATION;

export const getSelectedTreatmentTypes = (
  specification: VenueListingSpecificationOutput,
  cmsFilters: CmsFilters
) => {
  const selectedTreatmentTypes = [];

  if (specification.yieldDiscounted) {
    selectedTreatmentTypes.push(cmsFilters['smart-discounts']);
  }

  if (isExpressTreatmentTypeSelected(specification)) {
    selectedTreatmentTypes.push(cmsFilters['express-treatments']);
  }

  return selectedTreatmentTypes;
};
